const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/navigation.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
interface NavigationSearch {
  isCircleDirectoryLink?: boolean;
  selectedLinkId?: number;
}
export const Route = createFileRoute("/_protected/_settingsLayout/settings/navigation")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>): NavigationSearch => ({
    selectedLinkId: search.selectedLinkId ? Number(search.selectedLinkId) : undefined,
    isCircleDirectoryLink: search.isCircleDirectoryLink === true ? true : undefined
  })
});